import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import './index.css';
import theme from './theme';
import App from './App';
import Homework from './Homework';
import HomePage from './HomePage';
import TeacherPage from './TeacherPage';
import GuidePage from './GuidePage';
import GuidePageManual from './GuidePageManual';
import NotFound from './NotFound';
import PaymentPage from './PaymentPage';
import reportWebVitals from './reportWebVitals';

// Календарь и таймлайн перенесены на отдельный сервер. Временный редирект (пути уберём позже).
function CalendarRedirect() {
  const crmHost = window.location.hostname === 'alt-service.lingva-pro.org'
    ? 'alt-crm.lingva-pro.org'
    : 'crm.lingva-pro.org';
  window.location.replace(`https://${crmHost}/calendar/timeline-v2`);
  return null;
}

// Ловит ошибки рендера (блок не отрисовался) и сообщает их в телеметрию.
class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { hasError: false }; }
  static getDerivedStateFromError() { return { hasError: true }; }
  componentDidCatch(error, info) {
    try {
      const component = ((info && info.componentStack) || '').trim().split('\n')[0] || null;
      if (window.__track) window.__track('render_error', { msg: (error && error.message) || String(error), component });
    } catch (e) { /* ignore */ }
  }
  render() {
    if (this.state.hasError) {
      return <div style={{ padding: 24, fontFamily: 'sans-serif' }}>Произошла ошибка. Обновите страницу.</div>;
    }
    return this.props.children;
  }
}

// Сигнал, что приложение успешно смонтировалось (для отличия от app_stuck).
function ReadySignal() {
  useEffect(() => {
    window.__APP_READY__ = true;
    if (window.__track) window.__track('app_ready');
  }, []);
  return null;
}

const root = ReactDOM.createRoot(document.getElementById('root'));

// Меняется превью-пультом: новый key перемонтирует страницы, и они заново запрашивают данные
let previewEpoch = 0;

const renderApp = () => root.render(
  <React.StrictMode>
    <MantineProvider theme={theme} forceColorScheme="light">
      <ErrorBoundary key={previewEpoch}>
        <ReadySignal />
        <Router>
          <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/:userId" element={<App />} />
          <Route path="/:userId/homework/:taskId" element={<Homework />} />
          <Route path="/:userId/guide" element={<GuidePage />} />
          <Route path="/:userId/payment" element={<PaymentPage />} />
          <Route path="/teacher/:teacherId" element={<TeacherPage />} />
          <Route path="/teacher/:teacherId/guide" element={<GuidePage />} />
          <Route path="/:userId/guide/:articleId" element={<GuidePageManual />} />
          <Route path="/teacher/:teacherId/guide/:articleId" element={<GuidePageManual />} />
          <Route path="/admin/:userId/calendar" element={<CalendarRedirect />} />
          <Route path="/:userId/timeline-v2" element={<CalendarRedirect />} />
          <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </ErrorBoundary>
    </MantineProvider>
  </React.StrictMode>
);

// Превью-пульт (буква «A») — только в `npm start`. В `npm run build` условие становится
// `if (false)`, и webpack не собирает ./devPreview вовсе.
if (process.env.NODE_ENV === 'development') {
  import('./devPreview')
    .then(({ installPreview }) => installPreview({ onChange: () => { previewEpoch += 1; renderApp(); } }))
    .catch((error) => console.error('Превью-пульт не загрузился:', error))
    .finally(renderApp);
} else {
  renderApp();
}

reportWebVitals();
